import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8e05af80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-content" }
const _hoisted_2 = { class: "t1" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hoverClass" }, "注册", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hoverClass" }, "丨", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hoverClass" }, "登录", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hoverClass" }, "丨", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hoverClass" }, "帮助", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hoverClass" }, "丨", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hoverClass" }, "丨", -1))
const _hoisted_10 = ["onClick"]

import footer1 from './Footer.vue';
import { CSSProperties, onMounted } from 'vue';
import { useRouter } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  __name: 'TestPage',
  setup(__props) {

onMounted(() => {});
const router = useRouter();
const jumpBack = () => {
    router.push({
        path: '/'
    });
};
const clickUrl = (url: string) => {
    window.open(url);
};
const jumpToMap = () => {
    let url = router.resolve({
        name: 'maps'
    });
    window.open(url.href, '_blank');
};
const headerStyle: CSSProperties = {};

const contentStyle: CSSProperties = {};

const footerStyle: CSSProperties = {};

return (_ctx: any,_cache: any) => {
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout_footer = _resolveComponent("a-layout-footer")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, { id: "con" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout_header, {
        class: "headerStyle",
        onClick: jumpBack
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _hoisted_4,
              _hoisted_5,
              _hoisted_6,
              _hoisted_7,
              _hoisted_8,
              _createElementVNode("span", {
                class: "hoverClass",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (clickUrl('http://www.ctnma.cn/')), ["stop"]))
              }, " 综合办公 "),
              _hoisted_9,
              _createElementVNode("span", {
                class: "hoverClass",
                onClick: _withModifiers(jumpToMap, ["stop"])
              }, "联系我们", 8, _hoisted_10)
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_a_layout_content, { class: "contentStyle" }, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }),
      _createVNode(_component_a_layout_footer, { class: "footerStyle" }, {
        default: _withCtx(() => [
          _createVNode(footer1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})